setMerge